import { Component } from '@angular/core';

@Component({
  selector: 'devicelayout',
  templateUrl: './devicelayout.component.html',
  styleUrls: ['./devicelayout.component.scss']
})
export class DeviceLayoutComponent {
  constructor() { }
}
